import React from 'react';
export default function FancyArrowLeft() {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3.7 5.51 15.64 12.98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8408 11.8848L4.76417 11.8848",
    stroke: "currentColor",
    strokeWidth: "1.7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19965 11.8848C8.67944 11.8848 9.63449 6.01167 13.333 6.01167",
    stroke: "currentColor",
    strokeWidth: "1.7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20563 11.8848C8.68541 11.8848 9.63449 17.9952 13.333 17.9952",
    stroke: "currentColor",
    strokeWidth: "1.7",
    strokeLinecap: "round"
  }));
}